import { invokeAndroidMethod } from './androidBridge'
import { extractCollection, isApiObject } from './api.parsers'
import type {
  ApiController,
  ConfigStore,
  CreateOrderResponse,
  GetAvailabilityRequest,
  Product,
  ProductAvailability,
  ProductCategory,
  SendOrderConfirmationRequest
} from './api.types'

const parseDeviceConfig = (result: unknown): ConfigStore => {
  if (typeof result === 'string') {
    const parsedResult = JSON.parse(result) as unknown

    if (!isApiObject(parsedResult)) {
      throw new Error('Android.getDeviceConfig returned an invalid config object.')
    }

    return parsedResult as unknown as ConfigStore
  }

  if (!isApiObject(result)) {
    throw new Error('Android.getDeviceConfig returned an invalid config object.')
  }

  return result as unknown as ConfigStore
}

const webviewController: ApiController = {
  config: async () => {
    const result = await invokeAndroidMethod<unknown>('getDeviceConfig')
    return parseDeviceConfig(result)
  },
  getProductCategories: async () => {
    const result = await invokeAndroidMethod<unknown>('getProductCategories')
    return extractCollection<ProductCategory>(result)
  },
  getProducts: async categoryId => {
    const result = await invokeAndroidMethod<unknown>('getProducts', { categoryId })
    return extractCollection<Product>(result)
  },
  getAvailability: async (request: GetAvailabilityRequest) => {
    const result = await invokeAndroidMethod<unknown>('getAvailability', request)
    return extractCollection<ProductAvailability>(result)
  },
  createOrder: async payload => invokeAndroidMethod<CreateOrderResponse>('createOrder', payload),
  sendOrderConfirmation: async ({ orderId, email }: SendOrderConfirmationRequest) => {
    await invokeAndroidMethod<unknown>('sendOrderConfirmation', { orderId, email })
  }
}

export default webviewController
